import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { api } from '~/services/api'
import Yup from '~/services/yup'

import { Select } from '~/components/Form'
import FormPagamento from '~/components/FormPagamento'

import { Container } from './styles'
import authHeaders from '~/util/authHeaders'

const { Iugu } = window

export default function ({ callback }) {
    const [tiposPagamento, setTiposPagamento] = useState([])
    const [tipoPagamentoSelecionado, setTipoPagamentoSelecionado] = useState(null)

    useEffect(() => {
        console.log('Modo teste Iugu habilitado:', process.env.REACT_APP_IUGU_TEST_MODE === 'true')

        Iugu.setAccountID(process.env.REACT_APP_IUGU_ACCOUNT_ID)
        Iugu.setTestMode(process.env.REACT_APP_IUGU_TEST_MODE === 'true')
    }, [])

    useEffect(() => {
        async function loadTiposPagamento() {
            let response = await api.get('tipo_pagamento', {
                params: { ativos: '1' }
            })

            const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
            const { cpf } = storedData.pessoal

            const aspirante = await api.get('associado', {
                params: {
                    cpf,
                    aspirante: 1,
                    medico: 0
                }
            })

            if (aspirante) {
                response = response.filter(tipo => tipo.id !== 4)
            } else {
                response = response.filter(tipo => tipo.id !== 7)
            }

            setTiposPagamento(response)
        }

        loadTiposPagamento()

        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if (storedData?.financeiro?.tipo.value) {
            setTipoPagamentoSelecionado(storedData.financeiro.tipo)
        }
    }, [])

    const handleSubmit = useCallback(async (values, { setSubmitting, setFieldError }, callbackCreditCard) => {
        if (!values.autorizado) {
            toast.warn('Você deve concordar com os termos antes de prosseguir.')

            setSubmitting(false)

            callbackCreditCard?.()

            return
        }

        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if (tipoPagamentoSelecionado.value !== 3) {
            storedData.financeiro = {
                ...values,
                tipo: tipoPagamentoSelecionado
            }

            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storedData))

            try {
                await api.post('associacao', storedData)

                callback(storedData.pessoal.crm)
            } catch (e) {
                toast.error(e.msg || 'Ocorreu um erro no processo de associação.')

                setSubmitting(false)
            }
        } else { // Apenas para pagamento com cartão de crédito
            const {
                numero, titular, cvv, autorizado
            } = values
            const mes = values.mes.value < 10 ? `0${values.mes.value}` : values.mes.value
            const ano = values.ano.value

            // Validação da data de vencimento do cartão
            try {
                Yup.string().future().validateSync(`${mes}/${ano}`)
            } catch (e) {
                setFieldError('mes', 'Seu cartão está vencido.')
                setFieldError('ano', 'Seu cartão está vencido.')
                setSubmitting(false)
                callbackCreditCard()
                return
            }

            const posicao = titular.indexOf(' ')
            const nome = titular.slice(0, posicao)
            const sobrenome = titular.slice(posicao + 1)

            const cartaoCredito = Iugu.CreditCard(numero, mes, ano, nome, sobrenome, cvv)
            const bandeira = Iugu.utils.getBrandByCreditCardNumber(numero)

            try {
                await (new Promise((resolve, reject) => {
                    Iugu.createPaymentToken(cartaoCredito, async payment => {
                        if (payment.errors) {
                            reject(payment.errors)
                        } else {
                            storedData.financeiro = {
                                token: payment.id,
                                bandeira,
                                tipo: tipoPagamentoSelecionado,
                                autorizado
                            }

                            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storedData))

                            try {
                                await api.post('associacao', storedData)

                                callback(storedData.pessoal.crm)

                                resolve()
                            } catch (e) {
                                reject(e)

                                setSubmitting(false)
                            }
                        }
                    })
                }))
            } catch (e) {
                if (e.verification_value) {
                    toast.error('O código de segurança é inválido.')
                } else if (e.expiration) {
                    toast.error('Este cartão está vencido.')
                } else if (e.record_invalid) {
                    toast.error('Número do cartão é inválido. Verifique e tente novamente.')
                } else if (e.adblock) {
                    toast.error('Por favor desabilite seu bloqueador de anúncios e recarregue a página para conseguir efetivar a transação com seu cartão de crédito!.')
                } else {
                    toast.error(e.msg || 'Ocorreu um erro no pagamento com cartão de crédito.')

                    await api.post('iugu/erro', {
                        stack: e
                    }, authHeaders())
                }
            } finally {
                setSubmitting(false)

                callbackCreditCard?.()
            }
        }
    }, [callback, tipoPagamentoSelecionado])

    return (
        <Container>
            <Select
                name="tipo_pagamento"
                label="Forma de pagamento recorrente"
                withoutForm
                onChange={selected => setTipoPagamentoSelecionado(selected)}
                options={tiposPagamento.map(tipo => ({
                    label: tipo.descricao,
                    value: tipo.id
                }))}
                value={tipoPagamentoSelecionado}
                isSearchable={false}
            />

            <FormPagamento
                tipoPagamento={tipoPagamentoSelecionado}
                onSubmit={handleSubmit}
            />
        </Container>
    )
}
